import T from 'i18n-react'

import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
} from 'redux-saga/effects'

import {
  get,
  post
} from 'helpers/RequestUtil'

import {
  FETCH_PROJECT_WORKFLOW_DETAILS,
  POST_WORKFLOW_STATE
} from './constants'

import {
  fetchProjectWorkflowDetails as fetchProjectWorkflowDetailsAction,
  fetchProjectWorkflowDetailsStart,
  fetchProjectWorkflowDetailsSuccess,
  fetchProjectWorkflowDetailsError,
  postWorkflowStateStart,
  postWorkflowStateSuccess,
  postWorkflowStateError,
  resetStateToChangeTo
} from './actions'


import { getWorkflowDetails } from 'containers/Project/View/actions'

import {
  overwriteTables,
} from 'containers/Entity/actions'

import {
  error as errorAction
} from 'containers/App/Notification/actions'



function getEntityData(data){
  if(data.entities.project_ae_detail_views && Object.values(data.entities.project_ae_detail_views)[0]){
    return Object.values(data.entities.project_ae_detail_views)[0]
  } else {
    return {}
  }
}

function* fetchProjectWorkflowDetails(action) {
  const { projectId } = action
  try {
    yield put(fetchProjectWorkflowDetailsStart())
    const data = yield call(
      get,
      `/api/fulcrum/projects/${projectId}/workflow_detail`
    )
    // Add new data to entities and results
    yield put(overwriteTables(data))
    // yield put(updateAEDetailsChange(getEntityData(data)))
    yield put(fetchProjectWorkflowDetailsSuccess())
  } catch(error) {
    yield put(errorAction(T.translate('project.lifecycle.fetchError')))
    yield put(fetchProjectWorkflowDetailsError(error))
  }
}

function* watchFetchProjectWorkflowDetails(){
  yield takeEvery(FETCH_PROJECT_WORKFLOW_DETAILS, fetchProjectWorkflowDetails)
}

function* postWorkflowState(action){
  try{
    const { projectId, workflowId, state } = action
    yield put(postWorkflowStateStart())
    yield call(
      post,
      'change_states',
      { workflowId, state },
      '/api/fulcrum/workflow/change_states'
    )
    yield put(postWorkflowStateSuccess())
    yield put(fetchProjectWorkflowDetailsAction(projectId))
    yield put(getWorkflowDetails())
    yield put(resetStateToChangeTo())
  } catch(error) {
    yield put(errorAction(T.translate('project.lifecycle.postError')))
    yield put(postWorkflowStateError(error))
  }
}

function* watchPostWorkflowState(){
  yield takeEvery(POST_WORKFLOW_STATE, postWorkflowState)
}

function* loadSagas() {
  yield all([
    fork(watchFetchProjectWorkflowDetails),
    fork(watchPostWorkflowState)
  ])
}

export default loadSagas
